import { useAppStore } from '@/stores/appStore'
import { Header } from '@/components/common/Header'
import { Footer } from '@/components/common/Footer'
import { Dashboard } from '@/components/dashboard/Dashboard'
import { ResourcesList } from '@/components/resources/ResourcesList'
import { ResourceDetail } from '@/components/resources/ResourceDetail'
import { MiddlewaresList } from '@/components/middlewares/MiddlewaresList'
import { MiddlewareForm } from '@/components/middlewares/MiddlewareForm'
import { ServicesList } from '@/components/services/ServicesList'
import { ServiceForm } from '@/components/services/ServiceForm'
import { PluginHub } from '@/components/plugins/PluginHub'
import { SecurityHub } from '@/components/security/SecurityHub'
import { DataSourceSettings } from '@/components/settings/DataSourceSettings'
import { ThemeProvider } from '@/components/theme-provider'
import { ErrorBoundary } from '@/components/error-boundary'
import { Toaster, TooltipProvider } from '@/components/ui'

function AppContent() {
  const { page, showSettings } = useAppStore()

  const renderPage = () => {
    switch (page) {
      case 'dashboard':
        return <Dashboard />
      case 'resources':
        return <ResourcesList />
      case 'resource-detail':
        return <ResourceDetail />
      case 'middlewares':
        return <MiddlewaresList />
      case 'middleware-form':
        return <MiddlewareForm />
      case 'services':
        return <ServicesList />
      case 'service-form':
        return <ServiceForm />
      case 'plugin-hub':
        return <PluginHub />
      case 'security':
        return <SecurityHub />
      default:
        return <Dashboard />
    }
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="container mx-auto px-4 py-8 flex-1">
        <ErrorBoundary>
          {renderPage()}
        </ErrorBoundary>
      </main>
      <Footer />
      {showSettings && <DataSourceSettings />}
      <Toaster />
    </div>
  )
}

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="middleware-manager-theme">
      <TooltipProvider>
        <AppContent />
      </TooltipProvider>
    </ThemeProvider>
  )
}

export default App
